export default {
  common: {
    filters: {
      startingDate: {
        label: 'Starting date',
        placeholder: 'YYYY-MM-DD hh:mm:ss'
      },
      endDate: {
        label: 'End date',
        placeholder: 'YYYY-MM-DD hh:mm:ss'
      },
      operationIds: {
        label: 'Operation Id(s)',
        placeholder: 'Select operation id(s)'
      },
      statuses: {
        label: 'Status(es)',
        placeholder: 'Select status(es)'
      },
      resultsNumber: {
        label: 'Number of results to display at page'
      }
    }
  }
};
